<p-toast></p-toast>
<p-toolbar>
  <ng-template pTemplate="left">
    <button pButton pRipple label="Новий запис" icon="pi pi-plus" class="p-button-success mr-2" [disabled]="editMode" (click)="addRow()"></button>
  </ng-template>
  <ng-template pTemplate="right">
    <p-button icon="pi pi-refresh" label="Оновити" (onClick)="reloadTable()" [disabled]="editMode"
              pTooltip="Оновити список" tooltipPosition="top"></p-button>
  </ng-template>
</p-toolbar>

<!-- [rows]="25" below is PrimeNG's own page-size input, unrelated to this
     component's `rows` array field bound to [value] just above it -- the
     whole exceptions list already comes back in one GET call (tens of rows,
     not thousands, and the backend has no paged/offset query to begin
     with), so pagination here is client-side over that in-memory array --
     no [lazy]/onLazyLoad, unlike clients.component.html's server-side
     paging over 6,447+ rows. -->
<p-table #ACT1 [value]="rows"
         [rowHover]="true"
         [resizableColumns]="true"
         [paginator]="true"
         [rows]="25"
         [rowsPerPageOptions]="[10,25,50]"
         [showCurrentPageReport]="true"
         currentPageReportTemplate="Показано з {first} по {last} із {totalRecords} записів"
         editMode="row"
         dataKey="uid"
         styleClass="p-datatable p-datatable-gridlines p-datatable-striped agent-customer-tier-list-table">
  <ng-template pTemplate="header">
    <tr>
      <th pResizableColumn style="width:6rem"></th>
      <th pResizableColumn width="20%">Компанія</th>
      <th pResizableColumn width="14%">Рівень</th>
      <th pResizableColumn width="16%">Відповідальний менеджер</th>
      <th pResizableColumn width="16%">Компанія (override)</th>
      <th pResizableColumn width="18%">Примітки</th>
      <th pResizableColumn width="12%">Дата зміни</th>
      <th pResizableColumn style="width:4rem"></th>
    </tr>
    <tr>
      <th style="width:6rem"></th>
      <th style="overflow: visible !important">
        <input pInputText type="text" (input)="ACT1.filter($event.target.value, 'customer_name', 'contains')"
               placeholder="Пошук" class="p-column-filter p-dropdown-filter-style">
      </th>
      <th class="overflow-visible">
        <p-dropdown [options]="tierOptions" optionLabel="label" optionValue="value" [showClear]="true"
                    placeholder="Всі" (onChange)="ACT1.filter($event.value, 'tier', 'equals')"
                    styleClass="p-column-filter p-dropdown-filter-style"></p-dropdown>
      </th>
      <th style="overflow: visible !important">
        <input pInputText type="text" (input)="ACT1.filter($event.target.value, 'account_manager_name', 'contains')"
               placeholder="Пошук" class="p-column-filter p-dropdown-filter-style">
      </th>
      <th style="overflow: visible !important">
        <input pInputText type="text" (input)="ACT1.filter($event.target.value, 'override_company_name', 'contains')"
               placeholder="Пошук" class="p-column-filter p-dropdown-filter-style">
      </th>
      <th>
        <input pInputText type="text" (input)="ACT1.filter($event.target.value, 'notes', 'contains')"
               placeholder="Пошук" class="p-column-filter p-dropdown-filter-style">
      </th>
      <th></th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row let-editing="editing" let-ri="rowIndex">
    <tr [pEditableRow]="row">
      <td>
        <button *ngIf="!editing && !editMode" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(row)" class="p-button-rounded p-button-text"></button>
        <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(row)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
        <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(row, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
      </td>
      <td style="overflow: visible !important">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <app-companyselector [selectedID]="row.customer_id" [showLabel]="false"
                                 [showEditButton]="false" [showAddButton]="false" [showSearchButton]="false"
                                 placeholder="Обрати компанію..." (selectedCompanyID)="row.customer_id = $event" [style]="{'width':'100%'}"></app-companyselector>
          </ng-template>
          <ng-template pTemplate="output">
            {{row.customer_name}}
            <button *ngIf="row.customer_id" pButton pRipple type="button" icon="pi pi-external-link"
                    (click)="onOpenClient(row)" class="p-button-rounded p-button-text p-button-sm ml-1"
                    pTooltip="Відкрити компанію в новій вкладці" tooltipPosition="top"></button>
          </ng-template>
        </p-cellEditor>
      </td>
      <td style="overflow: visible !important">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <p-dropdown [options]="tierOptions" [(ngModel)]="row.tier" optionLabel="label" optionValue="value" placeholder="Обрати рівень..." [style]="{'width':'100%'}"></p-dropdown>
          </ng-template>
          <ng-template pTemplate="output">{{tierLabel(row.tier)}}</ng-template>
        </p-cellEditor>
      </td>
      <td style="overflow: visible !important">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <app-personselector [parentCompany]="mainCompanyId" [selectedID]="row.account_manager" [showClear]="true" [showLabel]="false"
                                placeholder="Обрати менеджера..." (selectedPersonID)="row.account_manager = $event" [style]="{'width':'100%'}"></app-personselector>
          </ng-template>
          <ng-template pTemplate="output">{{row.account_manager_name}}</ng-template>
        </p-cellEditor>
      </td>
      <td style="overflow: visible !important">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <app-companyselector [parentCompany]="mainCompanyId" [selectedID]="row.override_company_id" [showLabel]="false"
                                 [showEditButton]="false" [showAddButton]="false" [showSearchButton]="false"
                                 placeholder="—" (selectedCompanyID)="row.override_company_id = $event" [style]="{'width':'100%'}"></app-companyselector>
          </ng-template>
          <ng-template pTemplate="output">{{row.override_company_name}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="row.notes" style="width:100%"></ng-template>
          <ng-template pTemplate="output">{{row.notes}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <small>{{row.tier_set_by_name || row.tier_set_by}}<ng-container *ngIf="row.tier_set_at"> ({{row.tier_set_at | date:'short'}})</ng-container></small>
      </td>
      <td>
        <button *ngIf="!editing" pButton pRipple type="button" icon="pi pi-trash" [disabled]="editMode" (click)="deleteRow(row)" class="p-button-rounded p-button-text p-button-danger"></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr><td colspan="8">Немає клієнтів з нестандартним рівнем</td></tr>
  </ng-template>
</p-table>
